/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_PartnersInputs */

const en_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Partners`)
};

const es_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestros socios`)
};

const de_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Partner`)
};

const zh_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们的合作伙伴`)
};

const ar_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شركاؤنا`)
};

const fr_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nos partenaires`)
};

const vi_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đối tác của chúng tôi`)
};

const sw_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Washirika wetu`)
};

const th_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พันธมิตรของเรา`)
};

const bs_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naši partneri`)
};

const ja_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パートナー`)
};

const ko_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파트너`)
};

const pt_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nossos Parceiros`)
};

const it_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nostri partner`)
};

const sv_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Våra partners`)
};

const nl_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze partners`)
};

const da_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores partnere`)
};

const nb_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Våre partnere`)
};

const fi_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteistyökumppanimme`)
};

const pl_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasi partnerzy`)
};

const ru_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наши партнеры`)
};

const tr_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ortaklarımız`)
};

const hi_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे पार्टनर`)
};

const id_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitra kami`)
};

const ms_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rakan Kongsi Kami`)
};

const cs_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naši partneři`)
};

const el_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι εταίροι μας`)
};

const he_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השותפים שלנו`)
};

const af_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ons vennote`)
};

const hu_footer_partners = /** @type {(inputs: Footer_PartnersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnereink`)
};

/**
* | output |
* | --- |
* | "Our Partners" |
*
* @param {Footer_PartnersInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const footer_partners = /** @type {((inputs?: Footer_PartnersInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_PartnersInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_footer_partners(inputs)
	if (locale === "de") return de_footer_partners(inputs)
	if (locale === "zh") return zh_footer_partners(inputs)
	if (locale === "ar") return ar_footer_partners(inputs)
	if (locale === "fr") return fr_footer_partners(inputs)
	if (locale === "vi") return vi_footer_partners(inputs)
	if (locale === "sw") return sw_footer_partners(inputs)
	if (locale === "th") return th_footer_partners(inputs)
	if (locale === "bs") return bs_footer_partners(inputs)
	if (locale === "ja") return ja_footer_partners(inputs)
	if (locale === "ko") return ko_footer_partners(inputs)
	if (locale === "pt") return pt_footer_partners(inputs)
	if (locale === "it") return it_footer_partners(inputs)
	if (locale === "sv") return sv_footer_partners(inputs)
	if (locale === "nl") return nl_footer_partners(inputs)
	if (locale === "da") return da_footer_partners(inputs)
	if (locale === "nb") return nb_footer_partners(inputs)
	if (locale === "fi") return fi_footer_partners(inputs)
	if (locale === "pl") return pl_footer_partners(inputs)
	if (locale === "ru") return ru_footer_partners(inputs)
	if (locale === "tr") return tr_footer_partners(inputs)
	if (locale === "hi") return hi_footer_partners(inputs)
	if (locale === "id") return id_footer_partners(inputs)
	if (locale === "ms") return ms_footer_partners(inputs)
	if (locale === "cs") return cs_footer_partners(inputs)
	if (locale === "el") return el_footer_partners(inputs)
	if (locale === "he") return he_footer_partners(inputs)
	if (locale === "af") return af_footer_partners(inputs)
	if (locale === "hu") return hu_footer_partners(inputs)
	return en_footer_partners(inputs)
});